import { useRouter } from 'next/router';

export default function useQueryParams() {
  const router = useRouter();

  const id = typeof router.query.id === 'string' ? router.query.id : null;
  const slug = typeof router.query.slug === 'string' ? router.query.slug : null;

  const checkSlugParam = (value: unknown) => typeof value === 'string' && value.startsWith('@');

  if (checkSlugParam(id)) {
    return {
      id: '',
      slug: id?.slice(1),
    };
  }

  if (checkSlugParam(slug)) {
    return {
      id,
      slug: slug?.slice(1),
    };
  }

  return {
    id,
    slug: '',
  };
}
